export { default as AddContactScreen } from "./AddContact";
export { default as ViewContactScreen } from "./ViewContact";
export { default as ContactsScreen } from "./Contacts";
export { default as ContactTakePhotoScreen } from "./ContactTakePhoto";
